import SchemaOrg from './js/schema-org';

export {
    SchemaOrg,
};
